<!-- Hero Banner Section -->
<section
    class="relative bg-gradient-to-b from-[#102B51] via-[#163564] to-[#0D2240] text-white py-16 md:py-24 overflow-hidden">
    <!-- Decorative Ambient Glows -->
    <div class="absolute -top-24 -left-24 w-96 h-96 bg-emerald-500/20 rounded-full blur-3xl pointer-events-none"></div>
    <div class="absolute top-1/2 -right-24 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl pointer-events-none"></div>

    <div class="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div class="text-center max-w-3xl mx-auto space-y-4">
            <h1 class="text-3xl sm:text-4xl md:text-6xl font-bold tracking-tight text-white leading-tight">
                {{ productDetail?.name || 'Professional Documentation' }}
            </h1>

            <p class="text-gray-300 text-sm md:text-lg leading-relaxed max-w-2xl mx-auto">
                {{ productDetail?.description || 'Abadikan momen berharga dengan standar visual terbaik. Pilihan lengkap
                layanan dokumentasi foto, video sinematik, hingga liputan aerial drone profesional untuk segala jenis
                event Anda.' }}
            </p>

            <!-- Quick Trust Badges -->
            <div
                class="pt-4 flex flex-wrap justify-center items-center gap-4 md:gap-8 text-xs md:text-sm text-gray-300">
                <div class="flex items-center gap-2">
                    <svg class="w-5 h-5 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>Full-Frame & 4K Cinema Gear</span>
                </div>
                <div class="flex items-center gap-2">
                    <svg class="w-5 h-5 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>Pilot Drone Berlisensi Resmi</span>
                </div>
                <div class="flex items-center gap-2">
                    <svg class="w-5 h-5 text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd" />
                    </svg>
                    <span>Cloud Storage & Fast Delivery</span>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Main Products Section -->
<section class="py-16 md:py-24 px-4 md:px-8 bg-gray-50 relative">
    <div class="max-w-7xl mx-auto">
        <!-- Section Header -->
        <div class="text-center mb-12 md:mb-16">
            <h3 class="text-2xl md:text-4xl font-extrabold text-[#102B51]">
                Dokumentasi Service Unggulan
            </h3>
            <p class="text-gray-500 text-sm md:text-base mt-2 max-w-xl mx-auto">
                Pilih Dokumentasi service paling cocok buat kebutuhan
                event kamu di Visidea Studio lalu simpan di keranjang
                atau langsung checkout
            </p>
        </div>

        <!-- 3 Cards Grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-start">
            <div *ngFor="let product of products; let i = index"
                class="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 flex flex-col hover:-translate-y-2 relative">

                <!-- Badge (Top-Right) -->
                <div *ngIf="product.badge" class="absolute top-4 right-4 z-20">
                    <span [ngClass]="product.badgeColor"
                        class="text-white text-xs font-bold px-3.5 py-1.5 rounded-full shadow-md">
                        {{ product.badge }}
                    </span>
                </div>

                <!-- Product Image Cover -->
                <div class="relative h-64 overflow-hidden">
                    <img [src]="product.image" [alt]="product.name"
                        class="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-700">
                    <div class="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

                    <div class="absolute bottom-4 left-4 right-4 text-white">
                        <span class="text-xs font-medium text-emerald-300 uppercase tracking-wider block mb-1">
                            {{ product.category }}
                        </span>
                        <h4
                            class="text-xl font-bold text-white drop-shadow-sm group-hover:text-emerald-200 transition-colors">
                            {{ product.name }}
                        </h4>
                    </div>
                </div>

                <!-- Product Card Body -->
                <div class="p-6 flex-1 flex flex-col justify-between">
                    <div>
                        <!-- Pricing Section -->
                        <div class="flex items-baseline justify-between mb-4 pb-4 border-b border-gray-100">
                            <div>
                                <span class="text-xs text-gray-400 block font-medium">Mulai dari</span>
                                <div class="flex items-baseline gap-2">
                                    <span class="text-2xl md:text-3xl font-extrabold text-[#102B51]">
                                        {{ product.selectedPackageOption ? product.selectedPackageOption.priceFormatted
                                        : product.priceFormatted }}
                                    </span>
                                    <span *ngIf="product.originalPriceFormatted"
                                        class="text-xs text-gray-400 line-through">
                                        {{ product.originalPriceFormatted }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Short Description -->
                        <p class="text-gray-600 text-sm leading-relaxed mb-5 line-clamp-2">
                            {{ product.description }}
                        </p>

                        <!-- Key Feature Highlights -->
                        <div class="space-y-2.5 mb-5">
                            <!-- First 4 features -->
                            <div *ngFor="let feat of product.features.slice(0, 4)"
                                class="flex items-start gap-2.5 text-xs md:text-sm text-gray-700">
                                <span
                                    class="w-4 h-4 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center flex-shrink-0 mt-0.5 font-bold text-[10px]">
                                    ✓
                                </span>
                                <span class="leading-tight">{{ feat }}</span>
                            </div>

                            <!-- Expandable Details on Show More -->
                            <ng-container *ngIf="product.showMore">
                                <!-- Remaining features -->
                                <div *ngFor="let feat of product.features.slice(4)"
                                    class="flex items-start gap-2.5 text-xs md:text-sm text-gray-700 animate-fade-in">
                                    <span
                                        class="w-4 h-4 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center flex-shrink-0 mt-0.5 font-bold text-[10px]">
                                        ✓
                                    </span>
                                    <span class="leading-tight">{{ feat }}</span>
                                </div>

                                <!-- Package Duration Options (if variants exist) -->
                                <div *ngIf="product.packages && product.packages.length > 0"
                                    class="pt-3 pb-1 border-t border-gray-100 mt-4 space-y-2 animate-fade-in">
                                    <span class="text-xs font-bold text-gray-500 uppercase tracking-wider block">
                                        Pilih Opsi Paket Durasi:
                                    </span>
                                    <div class="grid grid-cols-1 gap-2">
                                        <div *ngFor="let pkg of product.packages"
                                            (click)="selectPackage(product, pkg, $event)"
                                            [ngClass]="{'border-emerald-500 bg-emerald-50/60 ring-2 ring-emerald-500/20 shadow-sm': product.selectedPackageOption?.id === pkg.id, 'border-gray-200 bg-slate-50 hover:bg-slate-100 hover:border-gray-300': product.selectedPackageOption?.id !== pkg.id}"
                                            class="p-2.5 rounded-xl border transition-all cursor-pointer flex items-center justify-between">
                                            <div>
                                                <div class="text-xs font-bold text-[#102B51]">{{ pkg.name }}</div>
                                                <div *ngIf="pkg.duration" class="text-[11px] text-gray-500">{{
                                                    pkg.duration }}</div>
                                            </div>
                                            <div class="text-xs font-extrabold text-emerald-700">{{ pkg.priceFormatted
                                                }}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Full Description (if different from short) -->
                                <div *ngIf="product.longDescription && product.longDescription !== product.description"
                                    class="mt-3 text-xs text-gray-600 bg-slate-50 p-3 rounded-2xl border border-slate-100 animate-fade-in">
                                    <span class="font-bold text-[#102B51] block mb-1">Deskripsi Lengkap:</span>
                                    <p class="leading-relaxed">{{ product.longDescription }}</p>
                                </div>

                                <!-- Deliverables if any -->
                                <div *ngIf="product.deliverables && product.deliverables.length > 0"
                                    class="mt-3 space-y-1.5 animate-fade-in">
                                    <span
                                        class="text-[11px] font-bold uppercase tracking-wider text-slate-400 block">Deliverables
                                        & Hasil Akhir:</span>
                                    <div *ngFor="let item of product.deliverables"
                                        class="flex items-start gap-2 text-xs text-gray-700 bg-gray-50 p-2 rounded-xl border border-gray-100">
                                        <span class="text-emerald-600 font-bold">✓</span>
                                        <span class="leading-tight">{{ item }}</span>
                                    </div>
                                </div>

                                <!-- Equipment if any -->
                                <div *ngIf="product.equipment && product.equipment.length > 0"
                                    class="mt-3 space-y-1.5 animate-fade-in">
                                    <span
                                        class="text-[11px] font-bold uppercase tracking-wider text-slate-400 block">Spesifikasi
                                        Peralatan:</span>
                                    <ul class="space-y-1 text-xs text-gray-600">
                                        <li *ngFor="let eq of product.equipment" class="flex items-center gap-2">
                                            <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                                            <span>{{ eq }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="space-y-2.5 pt-4 border-t border-gray-100">
                        <!-- Toggle Show More Button -->
                        <button type="button" (click)="toggleShowMore(product, $event)"
                            class="w-full py-2 text-xs font-semibold text-[#102B51] hover:text-[#202367] bg-slate-50 hover:bg-slate-100 rounded-xl transition flex items-center justify-center gap-1.5 cursor-pointer">
                            <span>{{ product.showMore ? 'Tutup Detail' : 'Lihat Detail Lengkap' }}</span>
                            <svg class="w-3.5 h-3.5 transition-transform duration-200"
                                [class.rotate-180]="product.showMore" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>

                        <div class="grid grid-cols-2 gap-2">
                            <!-- Add to Cart Button -->
                            <button (click)="addToCart(product, $event)"
                                class="w-full py-3 px-3 bg-white hover:bg-emerald-50 text-emerald-700 border border-emerald-600 font-semibold rounded-2xl transition-all duration-200 text-xs md:text-sm flex items-center justify-center gap-1.5 shadow-sm active:scale-95 cursor-pointer">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                                <span>Keranjang</span>
                            </button>

                            <!-- Checkout Button -->
                            <button (click)="checkout(product, $event)"
                                class="w-full py-3 px-3 bg-gradient-to-r from-[#202367] to-[#102B51] hover:from-[#191c53] hover:to-[#091b33] text-white font-semibold rounded-2xl transition-all duration-200 text-xs md:text-sm flex items-center justify-center gap-1.5 shadow-md hover:shadow-lg active:scale-95 cursor-pointer">
                                <span>Checkout</span>
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M14 5l7 7m0 0l-7 7m7-7H3" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>